import React, { useEffect } from "react";

import { usePageTitle } from "@/atoms/page-title-atom";
import { CustomerLtvView } from "@features/customer-ltv-v2/components";
import { CustomerLtvV2Provider } from "@features/customer-ltv-v2/context";

export const CustomerLtvV2 = () => {
  const [, setPageTitle] = usePageTitle();

  useEffect(() => {
    setPageTitle("Customer LTV");
  }, [setPageTitle]);

  return (
    <CustomerLtvV2Provider>
      <CustomerLtvView />
    </CustomerLtvV2Provider>
  );
};
